/**
 * Снимает service worker и очищает Cache Storage, затем перезагружает страницу.
 * Нужно после выката новой сборки, пока старый кэш PWA отдаёт устаревшие файлы.
 */
export async function applyPwaHardUpdate(): Promise<void> {
  try {
    if ("serviceWorker" in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch {
    /* ignore */
  }
  try {
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch {
    /* ignore */
  }
  window.location.reload();
}
